import script from "./MyVouchersForMerchantPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyVouchersForMerchantPage.vue?vue&type=script&setup=true&lang=ts"

import "./MyVouchersForMerchantPage.vue?vue&type=style&index=0&id=625d2c11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625d2c11"]])

export default __exports__